module.exports = __webpack_public_path__ + "img/img-151.8d93313c.png";